export const UMB_USER_ENTITY_TYPE = 'user';
export const UMB_USER_ROOT_ENTITY_TYPE = 'user-root';

export type UmbUserEntityType = typeof UMB_USER_ENTITY_TYPE;
export type UmbUserRootEntityType = typeof UMB_USER_ROOT_ENTITY_TYPE;
